import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    currentUser: localStorage.getItem('current-user') || null,
    isAuthenticated: localStorage.getItem('is-uthenticated') || false,
    token: localStorage.getItem('current-user-token') || null,
    userType: localStorage.getItem('current-user-type') || null,
    acl: JSON.parse(localStorage.getItem('acl')) || null,
  },
  getters: {
    currentUser(state) {
      return state.currentUser
    },
    isAuthenticated(state) {
      return state.token != null
    },
    token(state) {
      return state.token
    },
    userType(state) {
      return state.userType
    },
    acl(state) {
      return state.acl
    },
  },
  mutations: {
    UPDATE_CURRENT_USER(state, payload) {
      Vue.set(state, 'currentUser', payload.currentUser)
      localStorage.setItem('current-user', state.currentUser)
    },
    UPDATE_CURRENT_USER_TOKEN(state, payload) {
      Vue.set(state, 'token', payload.token)
      state.isAuthenticated = true
      localStorage.setItem('is-uthenticated', true)
      localStorage.setItem('current-user-token', state.token)
    },
    UPDATE_AUTHENTICATED(state, payload) {
      Vue.set(state, 'isAuthenticated', payload.isAuthenticated)
      localStorage.setItem('is-uthenticated', state.isAuthenticated)
    },
    SET_ACL(state, payload) {
      const aclObj = []
      Object.keys(payload.acl).forEach(key => {
        aclObj.push({
          action: payload.acl[key],
          subject: 'object',
        })
      })
      localStorage.setItem('acl', JSON.stringify(aclObj))
      Vue.set(state, 'acl', aclObj)
      // this.$ability.update(aclObj)
    },
    unsetAuth(state) {
      state.isAuthenticated = false
      state.acl = null
      state.currentUser = null
      state.token = null
      state.userType = null
      localStorage.removeItem('current-user-token')
      localStorage.removeItem('current-user-type')
      localStorage.removeItem('current-user')
      localStorage.removeItem('is-uthenticated')
      localStorage.removeItem('tmb_title')
      localStorage.removeItem('acl')
    },
    UPDATE_USER_TYPE(state, payload) {
      Vue.set(state, 'userType', payload.userType)
      localStorage.setItem('current-user-type', state.userType)
    },
  },
  actions: {
    logout({ commit }) {
      commit('unsetAuth')
    },
    authenticate({ commit }) {
      commit('UPDATE_CURRENT_USER_TOKEN')
    },
  },
}
